import React from "react";
import { WELCOME_BONUS_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const WelcomeBonus = Loadable(React.lazy(() => import("./View")));

export const WelcomeBonusRoute: IRouteItem = {
  path: WELCOME_BONUS_PATH,
  element: React.createElement(WelcomeBonus),
  name: "Welcome Bonus",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
};
